<template>
  <Sales 
    :fetchItems=fetchItems 
  />
</template>

<script>
import api from "@/api";
import Sales from "@/components/sales/Sales.vue"
// import { debounce } from "lodash";
export default {
  name: "SalesPage",
  components: {
    Sales
  },
  methods: {
    fetchItems(search, itemsPerPage, page) {
      return api.getSalesList(search, itemsPerPage, page);
    },
  },
};
</script>